if (!customElements.get("hoculus-swiper")) {
    class HoculusSwiper extends HTMLElement {
        async connectedCallback() {
            await hoculus.utils.swiperReady;

            if (document.readyState === "loading") {
                await new Promise((resolve) => document.addEventListener("DOMContentLoaded", resolve, { once: true }));
            }

            if (this.swiper || !this.isConnected) return;

            try {
                this.config = this.dataset.config ? JSON.parse(this.dataset.config) : {};
            } catch (error) {
                console.error("hoculus-swiper: data-config non valido", error);
                this.config = {};
            }

            this.swiper = new Swiper(this, this.config);
        }

        disconnectedCallback() {
            this.swiper?.destroy(true, true);
            this.swiper = null;
        }
    }

    customElements.define("hoculus-swiper", HoculusSwiper);
}
